<ng-container *ngIf='etichette; else waiting'>
    <ngb-toast *ngIf="toastConfig" [autohide]="true" [delay]="3000" (hidden)="toastConfig = undefined"
      [ngClass]="toastConfig.class">
        <container-element [ngSwitch]="toastConfig.class">
            <img *ngSwitchCase="'success'" src="assets/icone_varie/ok.svg" style="width: 20px; margin-right: 5px;">
            <img *ngSwitchCase="'warning'" src="assets/icone_varie/danger.svg" style="width: 20px; margin-right: 5px;">
            <img *ngSwitchCase="'error'" src="assets/icone_varie/error.svg" style="width: 20px; margin-right: 5px;">
        </container-element>
  
        {{toastConfig.title}}
    </ngb-toast>
      <div>
          <table class="table" >
            <thead>
              <tr >
                <th scope="col"  style="cursor: pointer; width: 25%">{{'configuration.etichette.name' | translate}}</th> 
                <th scope="col"  style="width: 25%">{{'configuration.etichette.color' | translate}}</th>
  
                <th scope="col" style='text-align: right; width: 10%'> 
                  <button type="button" class="btn btn-primary" (click)="refresh()" style="margin-right: 20px"><img src="assets/icone_varie/refresh.svg"></button>
                  <button type="button" class="btn btn-primary" (click)='addLabel()'><i class="bi bi-plus"></i> {{ 'general.add' | translate }}</button> </th>
              </tr>
            </thead> 
            <tbody>
              <tr *ngFor="let u of etichette" >
                <td>
                  <input type="text" class="form-control" [(ngModel)]="u.item.etichetta" [disabled]='!u.modify '>
                </td>
                <td>
                    <input *ngIf='!u.modify' type="text" class="form-control" disabled=true [placeholder]='u.item.colore'>
                    <div *ngIf='u.modify' class="dm7Select" >
                        <div class="select-side">
                          <img src="assets/icone_varie/arrow_down.svg">
                        </div>
                        <app-select class="selectDm7" 
                              [options]="colors" [key]="'key'" [value]="'key'"
                              [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="u.item.colore"
                              (change)="u.item.colore= $event.value;"></app-select>
                    </div>
                      
                </td>
                <td >
                  <button *ngIf='!u.modify' type="button" class="btn btn-primary" (click)="modifyLabel(u)" style='margin-right: 10px'><img src="assets/icone_varie/modifica.svg"></button>
                  <button *ngIf='u.modify' type="submit" class="btn btn-primary" style="margin-right: 10px;" (click)='save(u)'>{{ 'general.save' | translate }}</button>
                  <button type="button" class="btn btn-danger" (click)="deleteLabel(u)"><img src="assets/icone_varie/cestino.svg"></button>
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
      
        <ng-container *ngIf='etichette.length==0'>
          <div>
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
          </div>
        </ng-container>
  
  </ng-container>
  <ng-template #waiting>
      <app-loading></app-loading>
  </ng-template>